import { hasPermissionOnAtLeastOneForm, hasPermissionOnAtLeastOneFormPayment, hasPermissionOnAtLeastOneFormReceipt, hasPermissionOnBank, hasPermissionOnContacts, hasPermissionOnTapToPay, hasPermissionOnUserManagement, UserPermissions, UserRoles, } from "../enums";
import { DonorRoutes, OrganizationRoutes } from "../routes";
const permissionRedirectionInOrder = {
    [UserPermissions.Ticketing]: OrganizationRoutes.Campaigns,
    [UserPermissions.Donation]: OrganizationRoutes.Campaigns,
    [UserPermissions.Contacts]: OrganizationRoutes.Contacts,
    [UserPermissions.Bank]: OrganizationRoutes.Bank,
    [UserPermissions.Receipt]: OrganizationRoutes.Receipts,
    [UserPermissions.UserManagement]: OrganizationRoutes.Settings,
    [UserPermissions.TapToPay]: OrganizationRoutes.TapToPayInvitation,
};
export const getDefaultOrganizationRoute = (userPermissions) => {
    const defaultOrganizationRoute = OrganizationRoutes.Referral;
    if (!userPermissions || userPermissions?.length === 0) {
        return defaultOrganizationRoute;
    }
    const redirectionPermission = Object.keys(permissionRedirectionInOrder).find((orderedPermission) => userPermissions.includes(orderedPermission));
    return permissionRedirectionInOrder[redirectionPermission] ?? defaultOrganizationRoute;
};
export const getDefaultDonorRoute = () => {
    return DonorRoutes.DonorPaymentTable;
};
export const getDefaultRoute = (userPermissions, role) => {
    if (role === UserRoles.Donor) {
        return getDefaultDonorRoute();
    }
    return getDefaultOrganizationRoute(userPermissions);
};
const getDefaultRedirection = (newPermissions) => {
    if (hasPermissionOnAtLeastOneForm(newPermissions)) {
        return OrganizationRoutes.Campaigns;
    }
    if (hasPermissionOnAtLeastOneFormPayment(newPermissions)) {
        return OrganizationRoutes.Payments;
    }
    if (hasPermissionOnContacts(newPermissions)) {
        return OrganizationRoutes.Contacts;
    }
    if (hasPermissionOnBank(newPermissions)) {
        return OrganizationRoutes.Bank;
    }
    if (hasPermissionOnBank(newPermissions)) {
        return OrganizationRoutes.Bank;
    }
    if (hasPermissionOnAtLeastOneFormReceipt(newPermissions)) {
        return OrganizationRoutes.Receipts;
    }
    if (hasPermissionOnUserManagement(newPermissions)) {
        return OrganizationRoutes.Settings;
    }
    if (hasPermissionOnTapToPay(newPermissions)) {
        return OrganizationRoutes.TapToPayInvitation;
    }
    return null;
};
export const getDefaultOrganizationRouteFromNewPermissions = (newPermissions) => {
    const defaultOrganizationRoute = OrganizationRoutes.Referral;
    const { generalPermissions, formPermissions } = newPermissions || {};
    if (!newPermissions || !generalPermissions?.length || !formPermissions?.length) {
        return defaultOrganizationRoute;
    }
    return getDefaultRedirection(newPermissions) || defaultOrganizationRoute;
};
export const getDefaultRouteFromNewPermissions = (newPermissions, role) => {
    if (role === UserRoles.Donor) {
        return getDefaultDonorRoute();
    }
    return getDefaultOrganizationRouteFromNewPermissions(newPermissions);
};
